
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  MapPin,
  Users,
  BarChart3
} from 'lucide-react';
import { cn } from '@/lib/utils';

const bottomNavItems = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard },
  { name: 'Đơn hàng', href: '/orders', icon: Package },
  { name: 'Theo dõi', href: '/tracking', icon: MapPin },
  { name: 'Khách hàng', href: '/customers', icon: Users },
  { name: 'Báo cáo', href: '/reports', icon: BarChart3 },
];

const BottomNavigation = () => {
  const location = useLocation();

  return (
    <div className="fixed bottom-0 left-0 right-0 border-t shadow-lg" style={{ background: 'var(--gradient-primary)' }}>
      <div className="flex">
        {bottomNavItems.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={cn(
                'flex-1 flex flex-col items-center px-2 py-2 text-xs smooth-transition',
                isActive
                  ? 'text-white'
                  : 'text-white/70 hover:text-white'
              )}
            >
              <item.icon className={cn(
                'h-6 w-6 mb-1',
                isActive ? 'text-white' : 'text-white/60'
              )} />
              <span>{item.name}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;
